/* global grecaptcha */
'use strict';

var formValidation = require('brand_core/components/formValidation');
var createErrorNotification = require('base/components/errorNotification');
var scrollAnimate = require('brand_core/components/scrollAnimate');
var floatingLabel = require('brand_core/components/floatingLabel');
var formValidations = require('../utilities/formValidations');
var shippingHelpers = require('brand_core/checkout/shipping');

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

/**
 * Function to generate the reCAPTCHA token
 * @param {Object} form - The form to be submitted
 * @param {Object} e - The form submit event
 * @param {function} callback - The function to call after the token is generated
 */
function generateRecaptchaToken(form, e, callback) {
    var siteKey = $('.recaptcha-resetpassword').find('.custom-recaptcha-response').data('sitykey');
    var action = $('.recaptcha-resetpassword').find('.custom-recaptcha-response').data('action');

    if (siteKey) {
        grecaptcha.ready(function () {
            // Generate the reCAPTCHA token
            grecaptcha.execute(siteKey, { action: action }).then(function (token) {
                $('.recaptcha-resetpassword').find('.custom-recaptcha-response').val(token);
                callback(form, e);
            });
        });
    } else {
        callback(form, e);
    }
}

/**
 * Function to submit the reset password form
 * @param {Object} form - The form to be submitted
 * @param {Object} e - The form submit event
 */
function sendResetPasswordForm(form, e) {
    var url = form.attr('action');
    form.spinner().start();
    $('.reset-password-form').trigger('login:register', e);

    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: form.serialize(),
        success: function (data) {
            form.spinner().stop();
            if (!data.success) {
                formValidation(form, data);
            } else {
                $('.reset-password-link').data('title-modal', data.receivedMsgHeading);
                $('.forgot-password-link').data('title-modal', data.receivedMsgHeading);
                $('.forgot-password-modal').addClass('reset-state');
                $('.request-password-title').text(data.receivedMsgHeading);
                $('.request-password-body').empty()
                    .append('<p>' + data.receivedMsgBody + '</p>');
                $('.send-email-btn').hide();
                $('.reset-close-btn').removeClass('d-none');
            }
        },
        error: function () {
            form.spinner().stop();
        }
    });
}

$('.form-group input').keyup(function (e) {
    var code = (e.keyCode ? e.keyCode : e.which);
    if (code === 9 && $('input:focus').length) {
        $('input:focus:not(.tab-focus)').addClass('tab-focus');
    }
});

$('.form-group input').blur(function () {
    $(this).removeClass('tab-focus');
});

var $inputs = $('.login input');
$inputs.blur(function () {
    if (!$('.login .is-invalid').length) {
        $('.btn-primary.signin').removeAttr('disabled');
    } else {
        $('.btn-primary.signin').attr('disabled', true);
    }
});

$('#registration-form-email').on('change', function () {
    $('#registration-form-email-confirm').val($(this).val());
});

$(document).ready(function () {
    floatingLabel.refreshFloatingLabels();
});

$(document).on('click', '.toggle-password', function () {
    if ($(this).parent().find('.form-control').attr('type') === 'password') {
        $(this).text($(this).data('hide'));
        $(this).parent().find('.form-control').attr('type', 'text');
    } else {
        $(this).text($(this).data('show'));
        $(this).parent().find('.form-control').attr('type', 'password');
    }
});
$(document).on('blur', '#registration-form-password-confirm', function () {
    var errmsg = '<i class="fa fa-exclamation-circle error-message-icon" aria-hidden="true"></i><span></span>';
    var password = $('#registration-form-password').val();
    if (!$(this).siblings('.invalid-feedback').find('span').length) {
        $(this).siblings('.invalid-feedback').append(errmsg);
    }
    if ($(this).val() !== password && $(this).val() !== '') {
        $(this).addClass('is-invalid');
        $(this).siblings('.invalid-feedback').find('span').text($(this).attr('data-mismatch'));
        $(this).siblings('.invalid-feedback').show();
    } else {
        $(this).removeClass('is-invalid');
        $(this).siblings('.invalid-feedback').hide();
    }
});
$(document).on('click', '#registration-form-marketingpreference', function () {
    $('.registration-content .svg-chevron-down-wrapper svg').toggleClass('svg-up');
});
$(document).on('click', '.reset-password-link, .forgot-password-link', function () {
    var title = $(this).data('title-modal');
    var migrated = $(this).data('reset-migrated');
    if (title) {
        $('#requestPasswordResetModal .request-password-title').empty().append(title);
    }
    if (migrated) {
        $('.reset-password-form #reset-migrated').val(migrated);
    } else {
        $('.reset-password-form #reset-migrated').val('false');
    }
});

module.exports = {
    login: function () {
        $('form.login').on('submit', function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            form.spinner().start();
            $('form.login').trigger('login:submit', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (data.showValidateEmailAlert) {
                        form.find('.alert-danger').addClass('d-none');
                        $('.validate-email-alert .email-to-validate').text(data.emailToValidate);
                        $('.validate-email-alert .resend-validate-email-btn').removeClass('d-none');
                        $('.validate-email-alert .validate-email-sent-msg').addClass('d-none');
                        $('.validate-email-alert').removeClass('d-none').addClass('alert-danger');
                    } else if (data.showMigrateAlert) {
                        $('form.login').find('.migration-alert').remove();
                        form.prepend('<div class="migration-alert" role="alert">'
                        + '<div class="migration-msg mb-3">'
                        + data.migrateMessage.join('<br/>') +
                        '</div>' +
                         '<a class="reset-password-link" title="' + data.title
                        + '" data-title-modal = "' + data.title
                        + '" data-toggle="modal" href="' + data.resetPasswordUrl + '"  data-reset-migrated="true"  data-target="#requestPasswordResetModal"> '
                        + data.title + ' </a> </div>');
                    } else if (!data.success) {
                        formValidation(form, data);
                        $('form.login').trigger('login:error', data);
                        $('body, html').animate({ scrollTop: $(form).position().top }, 1000);
                    } else {
                        if (data.gtmDataLayer) {
                            window.dataLayer = window.dataLayer || [];
                            for (var i = 0; i < data.gtmDataLayer.length; i++) {
                                window.dataLayer.push(data.gtmDataLayer[i]);
                            }
                        }
                        $('form.login').trigger('login:success', data);
                        location.href = data.redirectUrl;
                    }
                },
                error: function (data) {
                    if (data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    } else {
                        $('form.login').trigger('login:error', data);
                        form.spinner().stop();
                    }
                }
            });
            return false;
        });
    },

    register: function () {
        $('form.registration').on('submit', function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            form.spinner().start();
            $('form.registration').trigger('login:register', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        formValidation(form, data);
                    } else {
                        if (data.gtmDataLayer) {
                            window.dataLayer = window.dataLayer || [];
                            for (var i = 0; i < data.gtmDataLayer.length; i++) {
                                window.dataLayer.push(data.gtmDataLayer[i]);
                            }
                        }
                        location.href = data.redirectUrl;
                    }
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification($('.error-messaging'), err.responseJSON.errorMessage);
                    }

                    form.spinner().stop();
                }
            });
            return false;
        });
    },

    resetPassword: function () {
        $('.reset-password-form').submit(function (e) {
            e.preventDefault();
            var form = $(this);

            // Call the function to generate the reCAPTCHA token and then submit the form
            generateRecaptchaToken(form, e, sendResetPasswordForm);

            return false;
        });
    },

    createAccount: function () {
        $(document).on('click', '.create-account-link', function (e) {
            e.preventDefault();
            $('.login-page').addClass('d-none');
            $('.registration-page').removeClass('d-none');
            scrollAnimate();
        });
    },

    clearResetForm: function () {
        $('#login .modal').on('hidden.bs.modal', function () {
            $('#reset-password-email').val('');
            $('.modal-dialog .form-control.is-invalid').removeClass('is-invalid');
        });
    },

    checkOrderStatus: function () {
        $('.trackorder').on('submit', function (e) {
            e.preventDefault();
            var $form = $(this);
            var url = $form.attr('action');
            var method = $form.data('method');
            var params = {
                csrf_token: $('input[name=csrf_token]').val(),
                isAjax: true
            };
            url = appendToUrl(url, params);
            var formData = $(this).serialize();
            $form.spinner().start();
            $.ajax({
                url: url,
                type: method,
                data: formData,
                success: function (data) {
                    if (data.error) {
                        $form.find('input').each(function () {
                            var validationMsg = $(this).data('missing-error') || $(this).data('pattern-mismatch');
                            if (validationMsg) {
                                $(this).addClass('is-invalid');
                                $(this).parent().find('.invalid-feedback').show()
                                    .html('<i class="fa fa-exclamation-circle error-message-icon" aria-hidden="true"></i><span>' + validationMsg + '<span>');
                            }
                        });
                    } else {
                        $('#maincontent').empty().append(data);
                        var newUrl = url.replace('isAjax=true', '');
                        window.history.pushState({ path: newUrl }, '', newUrl);
                        scrollAnimate();
                    }
                    $form.spinner().stop();
                },
                error: function () {
                    $form.spinner().stop();
                }
            });
        });
    },

    resendVerifyAccountEmail: function () {
        $('.resend-validate-email-btn').on('click', function () {
            var url = $(this).data('url');
            var emailToValidate = $('.validate-email-alert .email-to-validate').text();
            if (url && emailToValidate) {
                $.ajax({
                    url: url,
                    type: 'post',
                    dataType: 'json',
                    data: { email: emailToValidate.trim() },
                    success: function (data) {
                        if (data.error) {
                            $('.validate-email-alert').addClass('alert-danger').text(data.errorMessage);
                        } else {
                            $('.validate-email-alert .resend-validate-email-btn').addClass('d-none');
                            $('.validate-email-alert .validate-email-sent-msg').removeClass('d-none');
                        }
                    },
                    error: function () {
                        var errorMessage = $('.validate-email-alert').data('error-msg');
                        $('.validate-email-alert').addClass('alert-danger').text(errorMessage);
                    }
                });
            }
        });
    },

    birthdayValidation: function () {
        $(document).on('input', '#registration-form-bdate', function (e) {
            formValidations.birthdayValidation(e);
        });

        $(document).on('blur', '#registration-form-bdate', function () {
            formValidations.monthDateValidation($(this));
        });
    },

    getOperatingSystem: function () {
        var isApplePaySupport = window.ApplePaySession && window.ApplePaySession.canMakePayments();
        if (isApplePaySupport) {
            $('.express-checkout-section, #hazardousModal .apple-pay').addClass('ios-only');
        }
        if ((sessionStorage.getItem('stateCodeFromApplePay') === 'AK' || sessionStorage.getItem('stateCodeFromApplePay') === 'HI') && $('#isHazardousProducts').val() === 'true') {
            $('#hazardousModal').modal('show');
            sessionStorage.removeItem('stateCodeFromApplePay');
        }
        if (sessionStorage.getItem('countryIsGlobale') !== null) {
            shippingHelpers.methods.handleGlobaleCountry(sessionStorage.getItem('countryIsGlobale'));
            sessionStorage.removeItem('countryIsGlobale');
        }
        if (sessionStorage.getItem('countryIsNotValid') !== null) {
            $('.express-error-msg').removeClass('d-none');
            sessionStorage.removeItem('countryIsNotValid');
        }
        if (sessionStorage.getItem('applepayDataErrors') !== null) {
            var applepayDataErrors = sessionStorage.getItem('applepayDataErrors');
            if (applepayDataErrors.length) {
                $('.express-data-error-msg .error-fields').text(applepayDataErrors);
                $('.express-data-error-msg').removeClass('d-none');
            }
            sessionStorage.removeItem('applepayDataErrors');
        }
    }
};
